module.exports = __webpack_public_path__ + "91f434a29d67538d24ca2b2b515f3325.svg";